import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import '../../css/immocom.css';
import { DataIndicateur } from '../../data/DataIndicateur';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAnnee } from '../ComboBox/ComboBoxAnnee';
import { ComboBoxMois } from '../ComboBox/ComboBoxMois';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { FicheDetailIndicateurRecapitulatif } from '../Fiche/FicheDetailIndicateurRecapitulatif';
import '../List/DetailsListCG.css';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

var objetState = {
    items: [],
    selectedOperation: {},
    dateOuverturePeriode: null,
    labelPeriode: 'Période non ouverte',
    nomRegion: null,

    enCoursDeTraitement: false,
    messageEnCoursDeTraitement: '',

    onAffichePanelFiltre: false,
    onAffichePanelDetailIndicateur: false,

    onAfficheDialogClotureRegionale: false,
    onAfficheDialogClotureNationale: false,
    onAfficheDialogDecloture: false,
    onAfficheDialogRecalculIndicateurs: false,
    onAfficheDialogOuverturePeriode: false,

    onPeutChargerLeComposantFicheDetailIndicateurRecapitulatif: false,

    peutAccederSuiviBudgetaire: false,
    peutOuvrirNationale: false,
    peutCloturerNationale: false,
    peutCloturerRegionale: false,
    peutDecloturerRegionale: false,
    peutLancerRecalculIndicateur: false,

    filtreMois: 0,
    filtreAnnee: 0,

    pageIndex: 1,
    facteurNbreEnregistrement: 100,
    tri: "",

    hideMessageBarWarning: true,
    hideMessageBarError: true,
    warningMessage: '',
    errorMessage: ''
};

export class DetailsListCGRecapitulatif extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListCGRecapitulatifWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListCGRecapitulatifWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent() {
        const { items } = this.state;

        return (!this.state.peutAccederSuiviBudgetaire ? null :
            <DetailsList
                setKey="items"
                items={items}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                selectionMode={SelectionMode.none}
                columns={this.columns}
                onColumnHeaderClick={this._onColumnHeaderClick}
            />
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;

        //#region chargement des columns
        let columnsTemp = [];

        columnsTemp.push({
            key: 'dateClotureCG',
            name: 'Date clôture région.',
            ariaLabel: 'Date clôture régionale',
            fieldName: 'dateClotureCG',
            minWidth: 50,
            maxWidth: 120,
            isResizable: true,
            onRender: (item) => {
                let dateClotureCG = (item.dateClotureCG !== null ? Scriba.date().stringDateFormatCourt(item.dateClotureCG) : (item.dateClotureNationaleCG !== null ? '' : 'Ouverte'));
                return <span title={dateClotureCG} className={(dateClotureCG === 'Ouverte' ? 'labelDateClotureRegionaleOuverte' : '')}>{dateClotureCG}</span>;
            }
        });
        columnsTemp.push({
            key: 'dateClotureNationaleCG',
            name: 'Date clôture nation.',
            ariaLabel: 'Date clôture nationale',
            fieldName: 'dateClotureNationaleCG',
            minWidth: 50,
            maxWidth: 120,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isResizable: true,
            onRender: (item) => {
                let dateClotureNationaleCG = Scriba.date().stringDateFormatCourt(item.dateClotureNationaleCG);
                return <span title={dateClotureNationaleCG}>{dateClotureNationaleCG}</span>;
            }
        });
        columnsTemp.push({
            key: 'nomOperation',
            name: 'Opération',
            ariaLabel: 'Opération',
            fieldName: 'nomOperation',
            minWidth: 100,
            maxWidth: 500,
            isResizable: true,
            onRender: (item) => {
                return <span title={item.nomOperation}>{item.nomOperation}</span>;
            }
        });
        columnsTemp.push({
            key: 'statutReportingCGMois',
            name: 'Statut',
            ariaLabel: 'Statut',
            fieldName: 'statutReportingCGMois',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.statutReportingCGMois}>{item.statutReportingCGMois}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLgts',
            name: '(1) Nb lots',
            ariaLabel: 'Données d\'engagement début de période',
            fieldName: 'nbLgts',
            minWidth: 45,
            maxWidth: 90,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.nbLgts}>{item.nbLgts}</span>;
            }
        });
        columnsTemp.push({
            key: 'CA',
            name: '(1) CA HT',
            ariaLabel: 'Données d\'engagement début de période',
            fieldName: 'CA',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let CAHTDonneesEngagement = (item.ca !== null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.ca).toFixed(2), true, 2) + ' €' : null);
                return <span title={CAHTDonneesEngagement}>{CAHTDonneesEngagement}</span>;
            }
        });
        columnsTemp.push({
            key: 'reservationsBrutesNb',
            name: '(2) Nb lots',
            ariaLabel: 'Réservation brutes sur la période',
            fieldName: 'reservationsBrutesNb',
            minWidth: 45,
            maxWidth: 90,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.reservationsBrutesNb}>{item.reservationsBrutesNb}</span>;
            }
        });
        columnsTemp.push({
            key: 'reservationsBrutesCA',
            name: '(2) CA HT',
            ariaLabel: 'Réservation brutes sur la période',
            fieldName: 'reservationsBrutesCA',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let CAHTReservationsBrutes = (item.reservationsBrutesCA !== null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.reservationsBrutesCA).toFixed(2), true, 2) + ' €' : null);
                return <span title={CAHTReservationsBrutes}>{CAHTReservationsBrutes}</span>;
            }
        });
        columnsTemp.push({
            key: 'desistementsBrutsNb',
            name: '(3) Nb lots',
            ariaLabel: 'Désistements sur la période',
            fieldName: 'desistementsBrutsNb',
            minWidth: 45,
            maxWidth: 90,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.desistementsBrutsNb} className="labelDesistement">{item.desistementsBrutsNb}</span>;
            }
        });
        columnsTemp.push({
            key: 'desistementsBrutsCA',
            name: '(3) CA HT',
            ariaLabel: 'Désistements sur la période',
            fieldName: 'desistementsBrutsCA',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let CAHTDesistementsPeriode = (item.desistementsBrutsCA !== null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.desistementsBrutsCA).toFixed(2), true, 2) + ' €' : null);
                return <span title={CAHTDesistementsPeriode} className="labelDesistement">{CAHTDesistementsPeriode}</span>;
            }
        });
        columnsTemp.push({
            key: 'enStockNb',
            name: '(4) Nb lots',
            ariaLabel: 'Stock à fin de période',
            fieldName: 'enStockNb',
            minWidth: 45,
            maxWidth: 90,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.enStockNb}>{item.enStockNb}</span>;
            }
        });
        columnsTemp.push({
            key: 'enStockCA',
            name: '(4) CA HT',
            ariaLabel: 'Stock à fin de période',
            fieldName: 'enStockCA',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let CAHTStockFinPeriode = (item.enStockCA !== null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.enStockCA).toFixed(2), true, 2) + ' €' : null);
                return <span title={CAHTStockFinPeriode}>{CAHTStockFinPeriode}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLotsCommerciauxOptionnes',
            name: 'Nb lots optionnés',
            ariaLabel: 'Nb lots optionnés',
            fieldName: 'nbLotsCommerciauxOptionnes',
            minWidth: 45,
            maxWidth: 90,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.nbLotsCommerciauxOptionnes}>{item.nbLotsCommerciauxOptionnes}</span>;
            }
        });
        columnsTemp.push({
            key: 'detailIndicateur',
            name: '',
            ariaLabel: 'Voir le détail',
            fieldName: 'detailIndicateur',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: 'Search' }}
                    title="Voir le détail"
                    ariaLabel="Voir le détail"
                    onClick={() => this._onAffichePanelDetailIndicateur(item)}
                />;
            }
        });

        this.columns = columnsTemp;
        //#endregion
    }

    _getItems = () => {
        //let periodeOuverte = (this.state.labelPeriode !== 'Période non ouverte');
        let tableauBoutons = [];

        if (this.state.peutAccederSuiviBudgetaire) {
            let boutonCloturerMoisEnCours = {
                key: 'cloturerMoisEnCours',
                name: 'Clôturer le mois en cours',
                iconProps: {
                    iconName: 'ProtectRestrict'
                },
                onClick: (() => this._onAffichageDialogClotureRegionale()),
                disabled: !this.state.peutCloturerRegionale
            }

            tableauBoutons.push(boutonCloturerMoisEnCours);

            let boutonClotureNationale = {
                key: 'cloturerNationale',
                name: 'Clôture nationale',
                iconProps: {
                    iconName: 'Lock'
                },
                onClick: (() => this._onAffichageDialogClotureNationale()),
                disabled: !this.state.peutCloturerNationale
            }

            tableauBoutons.push(boutonClotureNationale);

            let boutonDecloturerMoisEnCours = {
                key: 'decloturerMoisEnCours',
                name: 'Déclôturer le mois en cours',
                iconProps: {
                    iconName: 'Unlock'
                },
                onClick: (() => this._onAffichageDialogDecloturer()),
                disabled: !this.state.peutDecloturerRegionale
            }

            tableauBoutons.push(boutonDecloturerMoisEnCours);

            let boutonOuverturePeriode = {
                key: 'ouverturePeriode',
                name: 'Ouvrir une période',
                iconProps: {
                    iconName: 'AddEvent'
                },
                onClick: (() => this._onAffichageDialogOuverturePeriode()),
                disabled: !this.state.peutOuvrirNationale
            }

            tableauBoutons.push(boutonOuverturePeriode);

            let boutonRecalculIndicateurs = {
                key: 'recalculIndicateurs',
                name: 'Recalcul des indicateurs',
                iconProps: {
                    iconName: 'Calculator'
                },
                onClick: (() => this._onAffichageDialogRecalculIndicateurs()),
                disabled: !this.state.peutLancerRecalculIndicateur
            }

            tableauBoutons.push(boutonRecalculIndicateurs);
        }

        return tableauBoutons;
    }

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des indicateurs en cours'
        });

        let chargementListeDesINDICATEURSRecapitulatif = DataIndicateur._chargementListeDesINDICATEURSRecapitulatif(this.state.tri, this.state.filtreMois, this.state.filtreAnnee, this.state.facteurNbreEnregistrement, this.state.pageIndex);

        chargementListeDesINDICATEURSRecapitulatif
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let new_Items = [];
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (objetData[0] !== null ? objetData[0] : []);
                    let periodeOuverture = objetData[1];

                    if (this.state.pageIndex === 1) {
                        new_Items = listeItem;
                    }
                    else {
                        new_Items = this.state.items;
                        new_Items = new_Items.concat(listeItem);
                    }

                    /* 20230509 : YD 
                     * labelPeriode: (periodeOuverture.mois !== null && periodeOuverture.annee !== null ? 'Période en cours : ' + periodeOuverture.mois + ' ' + periodeOuverture.annee : 'Période non ouverte'),
                     */
                    this.setState({
                        items: new_Items,
                        labelPeriode: (periodeOuverture !== null ? 'Période en cours : ' + periodeOuverture.mois + ' ' + periodeOuverture.annee : 'Période non ouverte'),
                        nomRegion: objetData[2],

                        peutAccederSuiviBudgetaire: objetData[3],
                        peutOuvrirNationale: objetData[4],
                        peutCloturerNationale: objetData[5],
                        peutCloturerRegionale: objetData[6],
                        peutDecloturerRegionale: objetData[7],
                        peutLancerRecalculIndicateur: objetData[8],

                        //peutEffectuerActionsNiveauNational: objetData[4],
                        //peutEffectuerActionsNiveauRegional: objetData[5],

                        filtreMois: (this.state.filtreMois === 0 ? (periodeOuverture != null && periodeOuverture.dateDebut !== null ? parseInt(Scriba.date().stringDateFormat(periodeOuverture.dateDebut, 'M')) : 0) : this.state.filtreMois),
                        filtreAnnee: (this.state.filtreAnnee === 0 ? (periodeOuverture != null && periodeOuverture.annee !== null ? periodeOuverture.annee : 0) : this.state.filtreAnnee),

                        enCoursDeTraitement: false,
                        messageEnCoursDeTraitement: '',
                        hideMessageBarWarning: true,
                        warningMessage: '',
                        hideMessageBarError: true,
                        errorMessage: ''
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.peutAccederSuiviBudgetaire = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _onClotureRegionale() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Clôture régionale en cours'
        });

        let onEnregistrementIndicateurClotureRegionale = DataIndicateur._onEnregistrementIndicateurClotureRegionale();

        onEnregistrementIndicateurClotureRegionale
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                this._onCacheDialogClotureRegionale();

                if (retourVerif === null) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onClotureNationale() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Clôture nationale en cours'
        });

        let onEnregistrementIndicateurClotureRegionale = DataIndicateur._onEnregistrementIndicateurClotureNationale();

        onEnregistrementIndicateurClotureRegionale
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                this._onCacheDialogClotureNationale();

                if (retourVerif === null) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onDeclotureRegionale() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Déclôture en cours'
        });

        let onEnregistrementIndicateurDeclotureRegionale = DataIndicateur._onEnregistrementIndicateurDeclotureRegionale();

        onEnregistrementIndicateurDeclotureRegionale
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                this._onCacheDialogDecloturer();

                if (retourVerif === null) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onRecalculIndicateurs() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Recalcul des indicateurs en cours'
        });

        let onEnregistrementRecalculIndicateurs = DataIndicateur._onEnregistrementRecalculIndicateurs();

        onEnregistrementRecalculIndicateurs
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                this._onCacheDialogRecalculIndicateurs();

                if (retourVerif === null) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onOuverturePeriode() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Ouverture de la période en cours'
        });

        let onEnregistrementOuverturePeriode = DataIndicateur._onEnregistrementOuverturePeriode(this.state.dateOuverturePeriode);

        onEnregistrementOuverturePeriode
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                this._onCacheDialogOuverturePeriode();

                if (retourVerif === null) {
                    this._chargementDonnees();
                    this.props.onOuverturePeriode();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAffichePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: true });
    }

    _onCachePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: false });
    }

    _onAffichePanelDetailIndicateur = (operation) => {
        this.setState({
            onAffichePanelDetailIndicateur: true,
            onPeutChargerLeComposantFicheDetailIndicateurRecapitulatif: true,
            selectedOperation: operation
        });
    }

    _onCachePanelDetailIndicateur = () => {
        if (this.state.onAffichePanelDetailIndicateur) {
            this.setState({
                onAffichePanelDetailIndicateur: false,
                onPeutChargerLeComposantFicheDetailIndicateurRecapitulatif: false
            });
        }
    }

    _onAffichageDialogClotureRegionale = () => {
        this.setState({
            onAfficheDialogClotureRegionale: true
        });
    }

    _onCacheDialogClotureRegionale = () => {
        this.setState({
            onAfficheDialogClotureRegionale: false
        });
    }

    _onAffichageDialogClotureNationale = () => {
        this.setState({
            onAfficheDialogClotureNationale: true
        });
    }

    _onCacheDialogClotureNationale = () => {
        this.setState({
            onAfficheDialogClotureNationale: false
        });
    }

    _onAffichageDialogDecloturer = () => {
        this.setState({
            onAfficheDialogDecloture: true
        });
    }

    _onCacheDialogDecloturer = () => {
        this.setState({
            onAfficheDialogDecloture: false
        });
    }

    _onAffichageDialogRecalculIndicateurs = () => {
        this.setState({
            onAfficheDialogRecalculIndicateurs: true
        });
    }

    _onCacheDialogRecalculIndicateurs = () => {
        this.setState({
            onAfficheDialogRecalculIndicateurs: false
        });
    }

    _onAffichageDialogOuverturePeriode = () => {
        this.setState({
            onAfficheDialogOuverturePeriode: true
        });
    }

    _onCacheDialogOuverturePeriode = () => {
        this.setState({
            onAfficheDialogOuverturePeriode: false
        });
    }

    _onSelectDate(value) {
        var valeurDate = Scriba.date().getChaineISOFromDate(value, true);
        this.setState({ dateOuverturePeriode: valeurDate });
    }

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState({
            filtreMois: 0,
            filtreAnnee: 0
        });
    }

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );

    }

    _incrementeNbreEnregistrementEtChargementDonnees = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
                { }
            </Sticky>
        );
    }

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    }

    _onRenderFooterDetailIndicateurContent = () => {
        return (
            <div>
                <DefaultButton onClick={this._onCachePanelDetailIndicateur}>Fermer</DefaultButton>
            </div>
        );
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.filtreMois !== 0 || this.state.filtreAnnee !== 0 ? `Période choisie : ${Immocom.conversion().getMoisAPartirNumero(this.state.filtreMois)} ${this.state.filtreAnnee}` : ""}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        <Sticky stickyPosition={StickyPositionType.Header}>
                            <div className="labelPeriodeEnCours">{this.state.labelPeriode}</div>
                        </Sticky>
                        <Sticky stickyPosition={StickyPositionType.Header}>
                            <div className="labelExplicatifColonnes">(1) Données d'engagement début de période / (2) Réservations brutes sur la période / (3) Désistements sur la période / (4) Stock à fin de période</div>
                        </Sticky>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={() => this._reinitFiltre()}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxMois
                                onChange={(event, option, index, value, item) => this.setState({ filtreMois: option.key })}
                                selectedKey={this.state.filtreMois}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxAnnee
                                onChange={(event, option, index, value, item) => this.setState({ filtreAnnee: option.key })}
                                selectedKey={this.state.filtreAnnee}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            <FicheDetailIndicateurRecapitulatif
                onAffichePanelDetailIndicateurRecapitulatif={this.state.onAffichePanelDetailIndicateur}
                idOperation={this.state.selectedOperation.idOperation}
                mois={this.state.filtreMois}
                annee={this.state.filtreAnnee}
                titre={`Détail de l'indicateur pour l'opération ${this.state.selectedOperation.nomOperation}`}
                onAnnuleFiche={() => this._onCachePanelDetailIndicateur()}
                onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheDetailIndicateurRecapitulatif}
            />

            <Dialog
                hidden={!this.state.onAfficheDialogClotureRegionale}
                onDismiss={this._onCacheDialogClotureRegionale}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Clôturer le mois en cours',
                    subText: `Etes-vous certain de vouloir clôturer la période en cours ${this.state.nomRegion !== null ? 'pour la région ' + this.state.nomRegion : ''} ? L'opération peut prendre un certain temps, merci de patienter`
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._onClotureRegionale()} disabled={this.state.enCoursDeTraitement} text="Valider" />
                    <DefaultButton onClick={this._onCacheDialogClotureRegionale} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogClotureNationale}
                onDismiss={this._onCacheDialogClotureNationale}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Clôture nationale',
                    subText: 'Etes-vous certain de vouloir clôturer la période en cours ? L\'opération peut prendre un certain temps, merci de patienter'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._onClotureNationale()} disabled={this.state.enCoursDeTraitement} text="Valider" />
                    <DefaultButton onClick={this._onCacheDialogClotureNationale} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogDecloture}
                onDismiss={this._onCacheDialogDecloturer}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Déclôturer le mois en cours',
                    subText: `Etes-vous certain de vouloir déclôturer la période en cours ${this.state.nomRegion !== null ? 'pour la région ' + this.state.nomRegion : ''} ?`
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._onDeclotureRegionale()} disabled={this.state.enCoursDeTraitement} text="Valider" />
                    <DefaultButton onClick={this._onCacheDialogDecloturer} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogRecalculIndicateurs}
                onDismiss={this._onCacheDialogRecalculIndicateurs}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Recalcul des indicateurs',
                    subText: 'Etes-vous certain de vouloir recalculer les indicateurs pour la période en cours ? L\'opération peut prendre un certain temps, merci de patienter'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._onRecalculIndicateurs()} disabled={this.state.enCoursDeTraitement} text="Valider" />
                    <DefaultButton onClick={this._onCacheDialogRecalculIndicateurs} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogOuverturePeriode}
                onDismiss={this._onCacheDialogOuverturePeriode}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Ouverture de période',
                    subText: 'Veuillez saisir une période d\'ouverture. L\'opération peut prendre un certain temps, merci de patienter'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <EUIDatePicker
                    label="Date d'ouverture"
                    onSelectDate={date => this._onSelectDate(date)}
                    value={this.state.dateOuverturePeriode}
                />
                <DialogFooter>
                    <PrimaryButton onClick={() => this._onOuverturePeriode()} disabled={this.state.enCoursDeTraitement} text="Valider" />
                    <DefaultButton onClick={this._onCacheDialogOuverturePeriode} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>;
    }
}